import { render, staticRenderFns } from "./SessionExpiring.vue?vue&type=template&id=b3a513da&"
import script from "./SessionExpiring.vue?vue&type=script&lang=js&"
export * from "./SessionExpiring.vue?vue&type=script&lang=js&"
import style0 from "./SessionExpiring.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports